// 치료 이력 타임라인 — 약물 색·약어.
//   계열이 같으면 비슷한 색을 쓴다(EGFR-TKI 주황, 세포독성 파랑, 면역항암 초록, 항VEGF 보라 …).
//   글자색은 채움색을 어둡게 만들어 쓴다. 사전에 없는 약물은 이름 해시로 보조 팔레트에서 고른다.

const DRUGS = {
    // EGFR-TKI 1·2세대
    'Erlotinib': ['#F5C4B3', 'Erl'],
    'Gefitinib': ['#F0997B', 'Gef'],
    'Afatinib': ['#E57A57', 'Afa'],
    // EGFR 3세대 · 기타 EGFR
    'Osimertinib': ['#FAC775', 'Osi'],
    'Lazertinib': ['#EF9F27', 'Laz'],
    'Amivantamab': ['#F6D28F', 'Ami'],
    'Mobocertinib': ['#F3B45C', 'Mobo'],
    // ALK · ROS1 · RET · BRAF 등 표적
    'Crizotinib': ['#E6D37A', 'Criz'],
    'Alectinib': ['#EDDC96', 'Alec'],
    'Lorlatinib': ['#D8C04F', 'Lorl'],
    'Brigatinib': ['#F1E4AA', 'Brig'],
    'Ceritinib': ['#E0CB6A', 'Cer'],
    'Repotrectinib': ['#D4BE5C', 'Repo'],
    'Selpercatinib': ['#CFE08A', 'Selp'],
    'Dabrafenib': ['#C7DB7A', 'Dab'],
    'Trametinib': ['#B6CF62', 'Tram'],
    'Lenvatinib': ['#D9E6A3', 'Lenv'],
    'Regorafenib': ['#C2D68E', 'Rego'],
    // 백금계
    'Carboplatin': ['#D3D1C7', 'Carbo'],
    'Cisplatin': ['#B9B6AA', 'Cis'],
    'Oxaliplatin': ['#C8C4B5', 'Oxa'],
    // 세포독성
    'Pemetrexed': ['#85B7EB', 'Pem'],
    'Vinorelbine': ['#B5D4F4', 'Vin'],
    'Docetaxel': ['#378ADD', 'Doc'],
    'Paclitaxel': ['#6FA3E0', 'Pac'],
    'Nab-paclitaxel': ['#9DC3EE', 'nPac'],
    'Gemcitabine': ['#4F8FD0', 'Gem'],
    'Etoposide': ['#A9C8EE', 'Eto'],
    'Irinotecan': ['#5E9BD8', 'Iri'],
    'Capecitabine': ['#7DB0E6', 'Cape'],
    'TS-1': ['#92BDEA', 'TS-1'],
    '5-FU': ['#6AA6E3', '5-FU'],
    'Leucovorin': ['#BCD6F2', 'LV'],
    'Trifluridine': ['#8BB5E4', 'FTD'],
    'Tipiracil': ['#A3C4EA', 'TPI'],
    'Cyclophosphamide': ['#7FA8D9', 'Cyc'],
    'Doxorubicin': ['#E58B8B', 'Dox'],
    'Doxorubicin(liposomal)': ['#EBA3A3', 'PLD'],
    'Bleomycin': ['#9FB9DA', 'Bleo'],
    // 복합 요법(한 이름으로 입력된 것)
    'FOLFOX': ['#8FA3E3', 'FOLFOX'],
    'FOLFIRI': ['#A5B4EA', 'FOLFIRI'],
    'FOLFIRINOX': ['#7C8FD8', 'FFX'],
    'XELOX': ['#B7C3EF', 'XELOX'],
    'CAPOX': ['#B7C3EF', 'CAPOX'],
    'CAPIRI': ['#9AAAE4', 'CAPIRI'],
    // 면역항암
    'Nivolumab': ['#9FE1CB', 'Nivo'],
    'Pembrolizumab': ['#5DCAA5', 'Pembro'],
    'Atezolizumab': ['#7FD6B9', 'Atezo'],
    'Durvalumab': ['#B8EBD9', 'Durva'],
    'Oleclumab': ['#8ED9C0', 'Olec'],
    // 항VEGF
    'Bevacizumab': ['#AFA9EC', 'Bev'],
    'Ramucirumab': ['#C5C0F2', 'Ram'],
    'Aflibercept': ['#9993E0', 'Afl'],
    // HER2 · EGFR 항체
    'Trastuzumab': ['#F4A6C8', 'Tras'],
    'Pertuzumab': ['#F7C4DA', 'Pert'],
    'Cetuximab': ['#E7A0D0', 'Cetux'],
    // 호르몬
    'Letrozole': ['#E8B4E0', 'Letro'],
    'Tamoxifen': ['#DDA3D6', 'Tam'],
};

// 사전에 없는 약물용 — 서로 구분되는 중간 채도 색
const EXTRA = ['#C9B8A3', '#A8C5B5', '#C4B0CF', '#B9C7A0', '#D6B3A8', '#A7BCD1', '#CFC39E', '#B8A9C9'];

export const UNKNOWN_FILL = '#E3E1DA';

function hash(s) {
    let h = 0;
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
    return Math.abs(h);
}

// 채움색을 어둡게 — 글자색
export function darken(hex, amount = 0.72) {
    const n = parseInt(hex.slice(1), 16);
    const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    const f = (c) => Math.round(c * (1 - amount)).toString(16).padStart(2, '0');
    return '#' + f(r) + f(g) + f(b);
}

export function drugStyle(name) {
    const key = String(name || '').trim();
    const hit = DRUGS[key]
        || DRUGS[Object.keys(DRUGS).find((k) => k.toLowerCase() === key.toLowerCase())];
    const fill = hit ? hit[0] : (key ? EXTRA[hash(key) % EXTRA.length] : UNKNOWN_FILL);
    const abbr = hit ? hit[1] : (key.length <= 6 ? key : key.slice(0, 4));
    return { fill, text: darken(fill), abbr, known: !!hit };
}

// 방사선 · 수술 · 채취 이벤트 색
export const EVENT_COLORS = {
    sampling: '#BA7517',
    radiation: '#534AB7',
    procedure: '#0F6E56',
};
